import script from "./NotariesInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./NotariesInfo.vue?vue&type=script&setup=true&lang=js"

import "./NotariesInfo.vue?vue&type=style&index=0&id=416812a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416812a6"]])

export default __exports__